import { COLORS } from "@treelab/panda";
import styled from "styled-components";

export const Container = styled.div<{ containerMixin?: string }>`
  ${(props) => props.containerMixin};
`;

export const Label = styled.div`
  margin-bottom: 8px;
  font-size: 13px;
  line-height: 16px;
  color: ${COLORS.grey};
`;

export const ChildrenContainer = styled.div<{ containerMixin?: string }>`
  ${(props) => props.containerMixin};
`;
